import { ReadableConfigValue } from './readable-config-value';

export enum FileCategory {
  // TODO: Add others here in the future
  MARK_IMAGE = 'MARK_IMAGE',
  ADDITIONAL_IMAGE = 'ADDITIONAL_IMAGE',
  REQUEST_FORM = 'REQUEST_FORM',
  FILING_REPORT = 'FILING_REPORT',
  FILING_OTHER = 'FILING_OTHER',
  FILING_RECEIPT = 'FILING_RECEIPT',
  AMENDED_CLAIMS = 'AMENDED_CLAIMS',
  FILING_CONFIRMATION = 'FILING_CONFIRMATION',
  APPLICATION_AS_FILED = 'APPLICATION_AS_FILED',
  IP_CASE_DETAILS = 'IP_CASE_DETAILS',
  RECORDAL_INSTRUCTIONS = 'RECORDAL_INSTRUCTIONS',
  SUPPORTING_COLLATERAL = 'SUPPORTING_COLLATERAL',
  PCT_PUBLICATION = 'PCT_PUBLICATION',
  PCT_PUBLICATION_WORD_FILE = 'PCT_PUBLICATION_WORD_FILE',
  VENDOR_TM_PACKAGE = 'VENDOR_TM_PACKAGE',
  TARGET_TM_FILE = 'TARGET_TM_FILE',
  CLIENT_INSTRUCTIONS = 'CLIENT_INSTRUCTIONS',
}

/**
 * Created by aeleneski on 6/15/2017.
 */
export interface FileCategoryType extends ReadableConfigValue {
  fileCategory?: FileCategory | string;
  fileCategoryType?: string;
  fileStatus?: string;
}
